import { useEffect } from "react";

const WHATSAPP_PHONE = "+91 92898 94123";
const WATI_SCRIPT_URL = "https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?72550";
const WATI_SCRIPT_ID = "wati-widget-script";

const WhatsAppWidget = () => {
  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const initWidget = () => {
      const options = {
        enabled: true,
        chatButtonSetting: {
          backgroundColor: "#00e785",
          ctaText: "Chat with us",
          borderRadius: "25",
          marginLeft: "18",
          marginRight: "20",
          marginBottom: "20",
          ctaIconWATI: false,
          position: "left"
        },
        brandSetting: {
          brandName: "Journal of Applied Bioanalysis",
          brandSubTitle: "Support",
          brandImg: "https://www.wati.io/wp-content/uploads/2023/04/Wati-logo.svg",
          welcomeText: "Hi there!\nHow can we help you?",
          messageText: "Hello, %0AI have a query regarding Article Publication",
          backgroundColor: "#00e785",
          ctaText: "Chat with us",
          borderRadius: "25",
          autoShow: false,
          phoneNumber: WHATSAPP_PHONE
        }
      };

      if (window.CreateWhatsappChatWidget) {
        window.CreateWhatsappChatWidget(options);
      }
    };

    const existingScript = document.getElementById(WATI_SCRIPT_ID);

    if (existingScript) {
      if (window.CreateWhatsappChatWidget) {
        initWidget();
      } else {
        existingScript.addEventListener("load", initWidget, { once: true });
      }
      return undefined;
    }

    const script = document.createElement("script");
    script.id = WATI_SCRIPT_ID;
    script.type = "text/javascript";
    script.async = true;
    script.src = WATI_SCRIPT_URL;
    script.onload = initWidget;

    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return null;
};

export default WhatsAppWidget;
